import { apiQuery } from '../';

export const getIntroApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getIntroById: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ introId }) => {
          return {
            method: 'get',
            url: `/intros/${introId}`,
          };
        },
      }),
      makeIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { subject, html, introId } = payload;
          return {
            url: '/intros/make',
            method: 'put',
            data: {
              requestee_html: html,
              requestee_subject: subject,
              id: introId,
            },
          };
        },
      }),
      makeBulkIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { subject, html, introIds } = payload;
          return {
            url: '/intros/bulk/make',
            method: 'post',
            data: {
              requestee_html: html,
              requestee_subject: subject,
              id: introIds,
            },
          };
        },
      }),
      askConsent: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { subject, html, introId } = payload;
          return {
            url: '/intros/ask_consent',
            method: 'put',
            data: {
              requestee_html: html,
              requestee_subject: subject,
              id: introId,
            },
          };
        },
      }),
      markDone: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { introId } = payload;
          return {
            url: '/intros/mark_done',
            method: 'put',
            data: {
              id: introId,
            },
          };
        },
      }),
      denyIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { reason, introId } = payload;
          return {
            url: '/intros/deny',
            method: 'put',
            data: {
              deny_reason: reason,
              id: introId,
            },
          };
        },
      }),

      //TODO remove this after the bulk intro flag is removed
      askIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { contactId, subject, body, requesteeId } = payload;
          return {
            url: '/intros',
            method: 'post',
            data: {
              contact_id: contactId,
              requestee_id: requesteeId,
              requester_subject: subject,
              requester_html: body,
            },
          };
        },
      }),

      askIntroToAllMutualConnection: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { contactId, subject, body, requesteesId } = payload;
          return {
            url: '/intros',
            method: 'post',
            data: {
              contact_id: contactId,
              requestee_id: requesteesId,
              requester_subject: subject,
              requester_html: body,
            },
          };
        },
      }),

      askBulkIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/intros/bulk/queue/request',
            method: 'post',
            data: { intros: payload },
          };
        },
      }),
      getIntroBatchUsers: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ batch_guid }) => {
          return {
            url: `/intros/${batch_guid}/batch_users`,
            method: 'get',
          };
        },
      }),

      removeIntroBatchUsers: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { batch_guid, userIds } = payload;
          return {
            url: `/intros/${batch_guid}/dequeue`,
            method: 'put',
            data: {
              requestee_id: userIds,
            },
          };
        },
      }),

      sendReminderForIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ introId, subject, body }) => {
          return {
            url: `/intros/send_reminder`,
            method: 'put',
            data: {
              id: introId,
              requester_subject: subject,
              requester_html: body,
            },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetIntroByIdQuery,
  useAskIntroMutation,
  useAskConsentMutation,
  useMarkDoneMutation,
  useDenyIntroMutation,
  useMakeIntroMutation,
  useMakeBulkIntroMutation,
  useAskBulkIntroMutation,
  useAskIntroToAllMutualConnectionMutation,
  useGetIntroBatchUsersMutation,
  useRemoveIntroBatchUsersMutation,
  useSendReminderForIntroMutation,
} = getIntroApi;
